<template>
  <div v-if="rerenderComponent">
    <form-wizard
      @on-complete="submitForm"
      @on-change="handleChangeStep"
      next-button-text="بعدی"
      back-button-text="قبلی"
      :finish-button-text="title"
      shape="tab"
      color="#556ee6"
    >
      <tab-content :before-change="validateAsync" title="نام اپلیکیشن">
        <ValidationObserver ref="step0" tag="div">
          <form class="needs-validation">
            <div class="row px-0">
              <div class="col-12 px-0">
                <div class="card px-0">
                  <div class="card-body">
                    <div class="row mt-4">
                      <div class="col-md-4">
                        <validation-input
                          v-model="form.name"
                          type="text"
                          placeholder="نام اپلیکیشن"
                          rules="required|max:190"
                          validation-field-name="نام اپلیکیشن"
                          label="نام اپلیکیشن"
                        ></validation-input>
                      </div>
                      <div class="col-md-4">
                        <validation-input
                          v-model="form.pkgNameAndroid"
                          type="text"
                          placeholder="نام پکیج اندروید"
                          rules="required|regex:^[a-z][a-z0-9_]*(\.[a-z0-9_]+)+[0-9a-z_]$"
                          validation-field-name="نام پکیج اندروید"
                          label="نام پکیج اندروید"
                        ></validation-input>
                      </div>
                      <div class="col-md-4">
                        <validation-input
                          v-model="form.pkgNameIos"
                          type="text"
                          placeholder="نام پکیج IOS"
                          rules="regex:^[a-z][a-z0-9_]*(\.[a-z0-9_]+)+[0-9a-z_]$"
                          validation-field-name="نام پکیج IOS"
                          label="نام پکیج IOS"
                        ></validation-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab-content>
      <tab-content :before-change="validateAsync" title="آیکن اپلیکیشن">
        <ValidationObserver ref="step1" tag="div">
          <form class="needs-validation">
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <validation-image-cropper-upload
                          rules="required"
                          validation-field-name="آیکن"
                          label="آیکن"
                          v-model="form.logoAddress"
                        ></validation-image-cropper-upload>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab-content>
      <tab-content
        :before-change="validateAsync"
        title="اطلاعات به روزرسانی اپلیکیشن"
      >
        <ValidationObserver ref="step2" tag="div">
          <form class="needs-validation">
            <div class="row px-0">
              <div class="col-12 px-0">
                <div class="card px-0">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <validation-input
                          v-model="form.appLink"
                          type="text"
                          rules="url"
                          placeholder="لینک اپلیکیشن"
                          validation-field-name="لینک اپلیکیشن"
                          label="لینک اپلیکیشن"
                        ></validation-input>
                      </div>
                      <div class="col-md-6">
                        <validation-input
                          v-model="form.versionName"
                          type="text"
                          rules="regex:\d+(?:\.\d+)+"
                          placeholder="ورژن"
                          validation-field-name="ورژن"
                          label="ورژن"
                        ></validation-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab-content>
      <tab-content
        :before-change="validateAsync"
        title="اطلاعات تکمیلی اپلیکیشن"
      >
        <ValidationObserver ref="step3" tag="div">
          <form class="needs-validation">
            <div class="row px-0">
              <div class="col-12 px-0">
                <div class="card px-0">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <validation-select
                          v-model="form.oriantation"
                          rules="required"
                          :options="orientationOptions"
                          placeholder="جهت نمایش اپلیکیشن"
                          option-value-key="id"
                          option-text-key="name"
                          validation-field-name="جهت نمایش اپلیکیشن"
                          label="جهت نمایش اپلیکیشن"
                        ></validation-select>
                      </div>
                      <div class="col-md-6">
                        <validation-select
                          v-model="form.categories"
                          type="text"
                          placeholder="دسته بندی"
                          rules="required|arrayMinLength:1"
                          :options="categoryOptions"
                          multiple
                          option-value-key="id"
                          option-text-key="name"
                          validation-field-name="دسته بندی"
                          label="دسته بندی"
                        ></validation-select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <validation-range-slider
                          :min="3"
                          :max="100"
                          v-model="form.age"
                          label="رده سنی"
                          validation-field-name="رده سنی"
                          rules="required"
                        ></validation-range-slider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import ValidationInput from '@/components/ValidationFormInputs/ValidationInput'
import { FormWizard, TabContent } from 'vue-form-wizard'
import ValidationRangeSlider from '@/components/ValidationFormInputs/ValidationRangeSlider'

export default {
  props: {
    id: {
      type: [Number, String, null],
      required: false,
    },
  },
  components: {
    ValidationInput,
    FormWizard,
    TabContent,
    ValidationRangeSlider,
  },
  data() {
    return {
      items: [
        {
          text: 'مدیریت اپلیکیشن ها',
          to: { name: 'applications' },
        },
        {
          text: 'ثبت اپلیکیشن جدید',
          active: true,
        },
      ],
      submitted: false,
      crudeForm: {
        name: '',
        pkgNameAndroid: '',
        pkgNameIos: '',
        logoAddress: '',
        appLink: '',
        versionName: '',
        oriantation: '',
        categories: [],
        age: [10, 40],
      },
      form: this.crudeForm,
      rerenderComponent: false,
      currentStep: 0,
      categoryOptions: [],
      orientationOptions: [
        {
          name: 'افقی',
          id: 0,
        },
        {
          name: 'عمودی',
          id: 1,
        },
        {
          name: 'هردو جهت',
          id: 2,
        },
      ],
    }
  },
  computed: {
    title() {
      return this.id ? 'ویرایش اپلیکیشن' : 'ثبت اپلیکیشن جدید'
    },
    isEditing() {
      return this.id != undefined && this.id != null
    },
  },
  watch: {
    '$route.fullPath': {
      immediate: true, // Immediate option to call watch handler on first mount
      handler() {
        this.resetForm()
      },
    },
  },
  mounted() {
    if (this.isEditing) {
      this.fetchRecord()
    } else {
      this.fetchCategories()
    }
  },
  methods: {
    fetchCategories() {
      this.$axios.get(`categories`).then((res) => {
        this.categoryOptions = res.data
        this.rerenderComponent = true
      })
    },
    fetchRecord() {
      this.$axios.get(`applications/${this.id}`).then((res) => {
        this.form = { ...this.form, ...res.data }
        this.form.age = [this.form.sen, this.form.senEnd]
        this.form.oriantation = this.orientationOptions.find(
          (option) => option.id === this.form.oriantation
        )
        this.fetchCategories()
      })
    },
    submitForm() {
      const data = JSON.parse(JSON.stringify(this.form))
      data.oriantation = data.oriantation.id
      const categories = []
      data.categories.forEach((item) => {
        categories.push(item.id)
      })
      data.categories = categories
      data.sen = data.age[0]
      data.senEnd = data.age[1]
      if (this.isEditing) {
        this.updateRecord(data)
      } else {
        this.createRecord(data)
      }
    },
    createRecord(data) {
      this.$axios.post('applications', data).then((res) => {
        this.$store.dispatch('tables/addNewItem', {
          key: 'applications',
          item: res.data,
        })
        this.$swal
          .fire('موفق!', `اپلیکشن با موفقیت ایجاد شد`, 'success')
          .then(() => {
            this.$router.push({ name: 'applications' })
          })
      })
    },
    updateRecord(data) {
      this.$axios.put(`applications/${this.id}`, data).then(() => {
        this.$swal
          .fire('موفق!', `اپلیکشن با موفقیت به روزرسانی شد`, 'success')
          .then(() => {
            this.$router.push({ name: 'applications' })
          })
        this.$store.dispatch('tables/updateItem', {
          key: 'applications',
          item: this.form,
        })
      })
    },
    resetForm() {
      this.rerenderComponent = false
      this.$nextTick(() => {
        this.form = this.crudeForm
        this.rerenderComponent = true
      })
    },
    async validateAsync() {
      const valid = await this.$refs[`step${this.currentStep}`].validate()
      return new Promise((resolve, reject) => {
        if (valid) {
          resolve(true)
        } else {
          reject()
        }
      })
    },
    handleChangeStep(prevIndex, nextIndex) {
      this.currentStep = nextIndex
    },
  },
}
</script>
